<template>
    <section class="section">
        <div class="container-fluid">
            <div class="columns">
                <div class="column">
                    <h1 class="title">{{ translate("live_scoreboards.title") }}</h1>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <p class="mb-3">{{ translate("live_scoreboards.desc") }}</p>
                    <div class="buttons">
                        <button v-for="mat in mats" class="button" :key="mat.id" @click="openMatInFrame(mat.id)">
                            {{ mat.name }}
                        </button>
                    </div>

                    <div class="buttons">
                        <button class="button is-light mr-2" :disabled="!enabledFullScreenButton" @click="copyLinkToClipboard">
                            <span class="icon">
                                <i class="fas fa-copy"></i>
                            </span>
                            <span>{{ translate("live_scoreboards.copy_link") }}</span>
                        </button>
                        <a class="button is-text" :disabled="!enabledFullScreenButton" :href="urlForFullScreen">
                            <span class="icon">
                                <i class="fas fa-expand-arrows-alt"></i>
                            </span>
                            <span>{{ translate("live_scoreboards.enter_full_screen") }}</span>
                        </a>

                        <p v-if="!!selectedMat" class="mb-2 has-text-weight-bold">
                            <span class="has-text-grey-light">{{ translate("live_scoreboards.selected_mat") }}</span>
                            {{ selectedMat.name }}
                        </p>
                    </div>
                </div>
            </div>

            <div>
                <iframe
                    v-show="initDone"
                    class="scoreboard-iframe"
                    v-if="!!liveScoreboardForMatUrl"
                    :src="liveScoreboardForMatUrl"
                    @load="loaded"
                ></iframe>
            </div>
            <div class="columns is-centered mt-5" v-if="!initDone">
                <LoadingSpinner2 />
            </div>
        </div>
    </section>
</template>

<script>
    import apiMixin from "../Api/apiMixin";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import urlsMixin from "../Urls/urlsMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import translatorMixin from "../Common/translatorMixin";
    import toastMixin from "../Common/toastMixin";

    export default {
        name: "live-scoreboards-app",
        components: { LoadingSpinner2 },
        mixins: [apiMixin, errorHandlerMixin, urlsMixin, translatorMixin, toastMixin],
        props: ["eventId"],
        data() {
            return {
                mats: [],
                selectedMatId: 0,
                initDone: false,
                liveScoreboardForMatUrl: "",
            };
        },
        computed: {
            selectedMat() {
                return this.mats.find(mat => mat.id === this.selectedMatId);
            },
            enabledFullScreenButton() {
                return !!this.liveScoreboardForMatUrl;
            },
            urlForFullScreen() {
                if (!this.enabledFullScreenButton) {
                    return "";
                }

                return this.eventAdmin().liveScoreboardForMatPage(this.eventId, this.selectedMatId);
            },
        },
        mounted() {
            return this.fetchMats().finally(() => (this.initDone = true));
        },
        methods: {
            fetchMats() {
                return this.matsApi()
                    .getMatsListing(this.eventId)
                    .then(result => (this.mats = result))
                    .catch(this.handleError);
            },
            openMatInFrame(matId) {
                if (this.selectedMatId === matId) {
                    return;
                }

                this.selectedMatId = matId;
                this.initDone = false;
                this.liveScoreboardForMatUrl = this.eventAdmin().liveScoreboardForMatPage(this.eventId, matId);
            },
            copyLinkToClipboard() {
                return navigator.clipboard.writeText(this.getFullLink(this.urlForFullScreen)).then(
                    () => {
                        this.successToast(this.translate("invitation_links.copied_to_clipboard"));
                    },
                    () => {},
                );
            },
            loaded() {
                this.initDone = true;
            },
            getFullLink(path) {
                return window.location.origin + path;
            },
        },
    };
</script>

<style scoped>
    .scoreboard-iframe {
        width: 100%;
        height: 56vh;
    }
</style>
